import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Shell } from "@/components/Shell";
import { useT } from "@/i18n";

const EMPTY = { name: "", email: "", password: "", phone: "", role: "worker", specialty: "" };

export default function AdminTeam() {
  const [staff, setStaff] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const { t } = useT();
  const load = () => api.get("/admin/users").then((r) => setStaff(r.data));
  useEffect(() => { load(); }, []);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/admin/users", form); toast.success(t("admin.created")); setForm(EMPTY); load(); } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  return (
    <Shell wide>
      <div className="rise"><p className="eyebrow">{t("admin.backoffice")}</p><h1 className="mt-2 font-serif text-4xl sm:text-5xl font-bold">{t("admin.team")}</h1></div>
      <div className="mt-8 grid lg:grid-cols-3 gap-6">
        <form onSubmit={submit} className="card-craft p-6 space-y-3" data-testid="staff-form">
          <h2 className="font-semibold">{t("admin.newStaff")}</h2>
          <div><label className="label-craft">{t("admin.role")}</label>
            <div className="grid grid-cols-2 gap-2">
              {[["worker", t("admin.worker")], ["partner", t("admin.partner")]].map(([v, l]) => (
                <button type="button" key={v} data-testid={`staff-role-${v}`} onClick={() => setForm({ ...form, role: v })} className={`rounded-xl border px-3 py-2.5 text-sm font-medium transition-colors ${form.role === v ? "border-terracotta bg-terracotta-light/60" : "border-craft"}`}>{l}</button>
              ))}
            </div>
          </div>
          <div><label className="label-craft">{t("admin.name")}</label><input data-testid="staff-name-input" className="input-craft" required value={form.name} onChange={set("name")} /></div>
          <div><label className="label-craft">{t("common.email")}</label><input data-testid="staff-email-input" type="email" className="input-craft" required value={form.email} onChange={set("email")} /></div>
          <div><label className="label-craft">{t("admin.initialPassword")}</label><input data-testid="staff-password-input" className="input-craft" minLength={6} required value={form.password} onChange={set("password")} /></div>
          <div><label className="label-craft">{t("admin.specialty")}</label><input data-testid="staff-specialty-input" className="input-craft" placeholder={t("admin.specialtyHint")} value={form.specialty} onChange={set("specialty")} /></div>
          <div><label className="label-craft">{t("auth.phone")}</label><input data-testid="staff-phone-input" className="input-craft" value={form.phone} onChange={set("phone")} /></div>
          <button data-testid="staff-submit-button" className="btn-primary w-full" disabled={busy}>{t("admin.createAccess")}</button>
          <p className="text-xs text-ink/50">{t("admin.partnersHint")}</p>
        </form>
        <div className="lg:col-span-2 card-craft divide-y divide-craft" data-testid="staff-list">
          {staff.map((s) => (
            <div key={s.id} className="flex items-center justify-between gap-4 px-6 py-4" data-testid={`staff-row-${s.email}`}>
              <div><div className="font-semibold">{s.name}</div><div className="text-xs text-ink/50">{s.email} {s.phone && `· ${s.phone}`} {s.specialty && `· ${s.specialty}`}</div></div>
              <span className={`rounded-full border px-3 py-1 text-xs font-semibold ${s.role === "partner" ? "bg-indigo-50 text-indigo-800 border-indigo-200" : "bg-emerald-50 text-emerald-800 border-emerald-200"}`}>{t(`role.${s.role}`)}</span>
            </div>
          ))}
          {staff.length === 0 && <p className="p-8 text-sm text-ink/50 text-center">{t("admin.noStaff")}</p>}
        </div>
      </div>
    </Shell>
  );
}
